module.exports = __webpack_public_path__ + "img/sjs-2.09a74928.png";